module.exports = __webpack_public_path__ + "media/images/logos/kinrgy-logo-3207ecea951067fd4fc7a6b8f8ea4b4d.svg";